<template>
<div class="container p-4">
    <div class="row">
        <div class="col-md-12">
            <div class="card">
                <div class="card-header p-4">
                    Scrap fiber diameter
                </div>
                <div class="card-body">
                    <p>
                        1. select your rectangle for analysing fiber diameter <br>
                        2. Click next<br>
                        3. Draw aline along your fiber diameter
                    </p>

                    <clipper-fixed v-if="showClipper" ref="clipper" class="mx-auto" :src="form.refimage.src" style="min-width:400px;max-width:400px;" :initWidth="900" :initHeight="900" :handle-zoom-event="zoom"></clipper-fixed>

                    <vue-drawing-canvas v-show="!showClipper" ref="VueCanvasDrawing" canvasId="VueCanvasDrawing" :width="400" :height="400" stroke-type="line" line-cap="butt" line-join="miter" color="#ff0000" :background-image="img" saveAs="png" :styles="{
                border: 'solid 1px #000',
                }" :lock="lock" @mousemove="getCoordinate($event)" />
                    <p v-if="fiber">
                        Your fiber diameter is {{fiber}} pixels.
                    </p>
                    <p>
                        <button class="btn btn-primary right m-4" @click="reset"> Reset </button>
                        <button class="btn btn-primary right m-4" v-if="showClipper" @click="clip"> Next step </button>
                        <button class="btn btn-primary right m-4" v-if="!showClipper && !fiber" @click="getCoordinate"> get diameter </button>
                        <button class="btn btn-primary right m-4" v-if="!showClipper && fiber" @click="useFd"> Use this value </button>
                    </p>
                </div>
            </div>

        </div>
    </div>

</div>
</template>

<script>
import {
    clipperFixed
} from 'vuejs-clipper'

import VueDrawingCanvas from "vue-drawing-canvas";

export default {
    props: ["form"],
    sync: ["refimage"],
    components: {
        clipperFixed,
        "vue-drawing-canvas": VueDrawingCanvas,
    },
    data() {
        return {
            img: null,
            showClipper: true,
            lock: false,
            scale: 1,
            fiber: null
        };
    },
    mounted() {

    },
    methods: {
        reset() {
            this.showClipper = true;
            this.fiber = null;
            this.scale = 1;
            this.lock = false;
        },
        clip: function () {
            console.log(this.$refs)
            const canvas = this.$refs.clipper.clip(); //call component's clip method
            this.img = canvas.toDataURL("image/jpeg", 1); //canvas->image
            this.showClipper = false;
            this.$refs.VueCanvasDrawing.redraw();

        },
        zoom(scale) {
            console.log(scale);
            this.scale = scale;
            return scale;

        },
        getCoordinate() {

            var strokes = this.$refs.VueCanvasDrawing.getAllStrokes();
            if (strokes.length > 0) {
                this.lock = true
                console.log("strokes");

                var stroke = strokes[0];
                console.log(JSON.stringify(stroke));

                var from = stroke.from
                var to = stroke.coordinates[0]
                var dist = this.distance(from, to);
                console.log(dist);
                this.fiber = Math.round(dist / this.scale);

            }

        },
        distance(pointA, pointB) {
            var dx = pointB.x - pointA.x;
            var dy = pointB.y - pointA.y;

            var dist = Math.sqrt(Math.pow(dx, 2) + Math.pow(dy, 2));

            return dist;
        },
        useFd() {

            this.form.fiber_diameter_value = this.fiber;
            this.$parent.showFiberdiameter = false;
        }

    }
}
</script>
